import clientJS from 'clientjs';
import * as R from 'ramda';
import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { Profile } from '../../types';
import { useUTMParams } from '../UTMParamsProcessor';
import useProfileStorage from '../../hooks/useProfileStorage';
import routes from '../../routes';

// const API_URL = 'http://localhost:3001';
const API_URL = 'https://3jx1f0our0.execute-api.us-east-1.amazonaws.com';

const client = new clientJS.ClientJS();

export const CREATE_PROFILE_URL = `${API_URL}/profiles`;

export function getFormPayload(
  submittedProfile: Profile,
  utmParams: ReturnType<typeof useUTMParams>,
) {
  const fingerprint = client.getFingerprint();
  const { company } = submittedProfile;

  return JSON.stringify({
    firstName: submittedProfile.firstName,
    role: submittedProfile.role,
    skills: R.map(R.pick(['id', 'name']), submittedProfile.skills || []),
    yearsOfExperience: submittedProfile.yearsOfExperience,
    country: submittedProfile.country,
    company: {
      country: company.country,
      numberOfEmployees: company.numberOfEmployees,
      createdAtYear: company.createdAtYear,
      financingAmount: company.financingAmount,
      name: company.name,
    },
    grossMonthlyCompensation: submittedProfile.grossMonthlyCompensation,
    utm: utmParams,
    browserFingerprint: fingerprint,
  });
}

export default function useSubmitForm() {
  const { isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const { deleteProfile } = useProfileStorage();
  const utmParams = useUTMParams();
  const [submitted, setSubmitted] = useState(false);
  const mutation = useMutation(async (submittedProfile: Profile) => {
    setSubmitted(true);
    const token = isAuthenticated && await getAccessTokenSilently();

    const res = await fetch(
      CREATE_PROFILE_URL,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: getFormPayload(submittedProfile, utmParams),
      },
    );
    if (!res.ok) throw new Error();
    deleteProfile();
    logout({ returnTo: `${window.location.origin}${routes.steps.success}` });
  });
  return [mutation, submitted, setSubmitted] as const;
}
